import { Avatar, ButtonBase, Fade, Tooltip } from '@mui/material';

import { UserProfilePictureDialog } from '~/components/Dialogs/UserProfilePictureDialog';
import { ChangePasswordDialog } from '~/features/ChangePassword';
import { useLibraryComponentContext } from '~/library/components/LibraryComponentContext';

import { ChangeLanguage } from '../ChangeLanguage';

import { UserProfileOptions } from './components/UserProfileOptions';
import { useLegacyUserProfile } from './useLegacyUserProfile';
import { useSxStyles } from './useStyles';

type PropsType = {
  renderProfileButton?: (buttonComponent: JSX.Element) => JSX.Element;
};

export const LegacyUserProfile = (props: PropsType) => {
  const { renderProfileButton } = props;
  const sxStyles = useSxStyles();

  const { onUpdateLegacy } = useLibraryComponentContext();

  const {
    employeeProfile,
    lastLoginTime,
    openDialogName,
    dialogOpenChange,
    resetDialog,
  } = useLegacyUserProfile();

  const ProfileButton = () => {
    return (
      <ButtonBase
        aria-controls="user-profile-menu"
        aria-haspopup="true"
        sx={{ overflow: 'hidden' }}
      >
        <Avatar
          variant="rounded"
          alt={`${employeeProfile.firstName} ${employeeProfile.lastName}`}
          src={employeeProfile.profilePic}
        />
      </ButtonBase>
    );
  };

  return (
    <>
      <Tooltip
        placement="bottom-end"
        leaveDelay={0}
        slots={{
          transition: Fade,
        }}
        slotProps={{
          popper: {
            sx: sxStyles.popper,
          },
        }}
        title={
          <UserProfileOptions
            lastLogin={lastLoginTime}
            employeeProfile={employeeProfile}
            onChangeLanguage={() => dialogOpenChange('changeLanguage')}
            onChangePassword={() => dialogOpenChange('changePassword')}
            onChangePicture={() => dialogOpenChange('changePicture')}
          />
        }
      >
        {!!renderProfileButton ? (
          renderProfileButton(<ProfileButton />)
        ) : (
          <ProfileButton />
        )}
      </Tooltip>
      <UserProfilePictureDialog
        open={openDialogName === 'changePicture'}
        onClose={resetDialog}
        onUpdateLegacy={onUpdateLegacy}
      />
      {openDialogName === 'changePassword' && (
        <ChangePasswordDialog open={true} onClose={resetDialog} />
      )}
      {openDialogName === 'changeLanguage' && (
        <ChangeLanguage resetDialog={resetDialog} />
      )}
    </>
  );
};
